module.exports = __webpack_public_path__ + "static/media/xtreem.921681be.webp";